/**
 * All Triplets — every set in the hand is a pung or kong, never a chi. The
 * pair doesn't count (pairs aren't sets). Checks exposed melds directly and
 * the remaining concealed tiles via `decomposeConcealedHand`.
 */

import { SETS_TO_WIN } from '../../game/types.js';
import { decomposeConcealedHand } from '../decompose.js';
import type { MatchedPattern, ScoringContext } from '../types.js';

const ALL_TRIPLETS_VALUE = 1;

export function matchAllTriplets(context: ScoringContext): MatchedPattern | null {
  const hasChiMeld = context.melds.some((meldEntry) => meldEntry.type === 'chi');
  if (hasChiMeld) return null;

  const setsNeeded = SETS_TO_WIN - context.melds.length;
  const decomposition = decomposeConcealedHand([...context.concealedTiles, context.winningTile], setsNeeded);
  if (decomposition === null) return null;
  const hasChiSet = decomposition.sets.some((set) => set.type === 'chi');
  if (hasChiSet) return null;

  return { name: 'allTriplets', kind: 'double', value: ALL_TRIPLETS_VALUE };
}
